// src/pages/leads/Pagination.jsx
import React from 'react';
import { Flex, Button, Text } from '@chakra-ui/react';

/**
 * Pagination
 * Simple Prev / Page / Next control.
 *
 * Props:
 * - page: number (current page, 1-based)
 * - hasNext: boolean (whether there is a next page)
 * - onPrev: () => void
 * - onNext: () => void
 * - isLoading?: boolean (optional; disables buttons while loading)
 */
export default function Pagination({
  page = 1,
  hasNext = false,
  onPrev,
  onNext,
  isLoading = false,
}) {
  const canPrev = page > 1 && !isLoading;
  const canNext = !!hasNext && !isLoading;

  return (
    <Flex mt={4} justify="space-between" align="center">
      <Button
        onClick={onPrev}
        isDisabled={!canPrev}
        variant="outline"
        size="sm"
      >
        ← Prev
      </Button>

      <Text fontSize="sm">Page {page}</Text>

      <Button
        onClick={onNext}
        isDisabled={!canNext}
        variant="outline"
        size="sm"
      >
        Next →
      </Button>
    </Flex>
  );
}
